import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerInvoice extends AManagerApi {
    protected _url: string = '/owner/invoice';
}
